export enum FeatureType {
  DISCOUNT = 'discount',
  CASH_BACK = 'cash_back',
  FLIGHT = 'flight',
  BENEFIT = 'benefit',
  MILEAGE = 'mileage',
  AIRPORT_SERVICE = 'airport_service',
  TRAVEL = 'travel',
  HOTEL = 'hotel',
  INSTALLMENT = 'installment',
}

export type Feature = {
  type: FeatureType;
  feedback: String;
  max_feedback: String;
  condition: String;
  simplified_condition: String;
  channel: String;
  release_date?: Date | string;
  due_date?: Date | string;
};
